export default __webpack_public_path__ + "assets/webgl/scene-1.46eba589.glb";